import React, { useEffect, useState } from "react";
import { Input, Button, message, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, getKillSwitchInfo } from "../../store/session";
import { usePrevious } from "../../hooks/usePrevious";
import constants from "../../configs/constants";
import app_logo from "../../assets/images/app_logo.png";
import { wsDisconnect, } from "../../store/pushback";

const styles = {
  container: {
    maxWidth: 500,
    marginLeft: "auto",
    marginRight: "auto",
  },
};
const Maintenance = (props) => {
  const user = useSelector((state) => state.session.user);
  const switchDataMessage = useSelector((state) => state.session.switchDataMessage);
  const switchData = useSelector((state) => state.pushback.switchData);
  const [switchMessage, setSwitchMessage] = useState();
  const [toggleSwitch, setToggleSwitch] = useState(false);
  const [switchLocalData, setSwitchLocalData] = useState(
    JSON.parse(localStorage.getItem("switchData")))
  const [switchLocalStatus, setSwitchLocalStatus] = useState(
    localStorage.getItem("switchStatus"))
  const [userLocal, setUserLocal] = useState(
    JSON.parse(localStorage.getItem("driverToken"))
  );
 
  
  const dispatch = useDispatch();
  const prevUser = usePrevious(user);

  // useEffect(() => {
  //   if (switchData && switchData[0].status === 'ON') {
  //     setTimeout(() => {
  //       dispatch(getKillSwitchInfo({message: 'getS3Message'}));
  //       reloadPage();
  //     }, 60000);
  //     console.log('reload pagee main')
  //   } else {
  //     console.log('switchData main dont do anything main')
  //   }
    
  // }, [switchData]);

  useEffect(() => {
    dispatch(getKillSwitchInfo({message: 'getS3Message'}));
  }, []);


  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("switchData"))
    let driver = JSON.parse(localStorage.getItem("driverToken"))
    let status = localStorage.getItem("switchStatus")
    setSwitchLocalData(data);
    setSwitchLocalStatus(status);
    setUserLocal(driver)
  }, []);

  useEffect(() => {
    if (userLocal) {
      console.log('user', userLocal)
      if (switchLocalStatus === 'OFF') {
        props.history.push("/driver");
      }
      
    }
  }, [switchLocalStatus]);


  useEffect(() => {
      if (switchLocalData) {
        // props.history.push("/driver");
        
        dispatch(wsDisconnect()); //disconnect websocket
        console.log('switchLocalData loopp disconnect', switchLocalData)
      }
      
  }, [switchLocalData]);

  // listens to websocket
  useEffect(() => {
    if (switchData) {
      console.log('switchData driver loop 2', switchData);
      console.log('switchData driver loop 2', typeof switchData);
      let data = switchData[0] ? switchData[0] : switchData;
      if (data.status === 'ON') {
        setToggleSwitch(true);
        setSwitchMessage(data.message)
        console.log('switchData hello')
      } else {
        setToggleSwitch(false)
        props.history.push("/driver");
      }
    }
  }, [switchData]);

  useEffect(() => {
    if (switchLocalData) {
      console.log('switchLocalData loop 3', switchLocalData)
      console.log('switchLocalData loop 3', typeof switchLocalData)
      let data = switchLocalData[0] ? switchLocalData[0] : switchLocalData;
      console.log('switchLocalData loop 3', data)
      if (data.status === 'ON') {
        setToggleSwitch(true);
        setSwitchMessage(data.message)
        setTimeout(() => {
          dispatch(getKillSwitchInfo({message: 'getS3Message'}));
          reloadPage();
        }, 30000);
        console.log('reload pagee main')
      } else {
        setToggleSwitch(false)
        props.history.push("/driver");
      }
    }
  }, [switchLocalData]);
  

  useEffect(() => {
    if (switchDataMessage) {
      console.log('switchData loop 4', switchDataMessage);
      console.log('switchData loop 5', typeof switchDataMessage);
      let data = switchDataMessage[0] ? switchDataMessage[0] : switchDataMessage;
      if (data.status === 'ON') {
        setToggleSwitch(true);
        setSwitchMessage(data.message)
      } else {
        setToggleSwitch(false);
      }
    }
  }, [switchDataMessage]);

  const reloadPage = () => {
    window.location.reload();
  };


  return (
    <div style={styles.container}>
      <div style={{ paddingTop: 100, paddingBottom: 50, textAlign: "center" }}>
        <Row type="flex" justify="center">
          <img src={app_logo} alt="app_logo" style={{ width: 200, height: "100%", paddingTop: 30, }} />
        </Row>
        <Row type="flex" justify="center"  style={{ paddingTop: 50, paddingBottom: 20, letterSpacing: '1px'}}>
          <Col>
            <div style={{ color: '#fff' }}>
              {/* <p>
              The site is currently undergoing maintenance.
              </p> */}
              {switchMessage && (
                <p>
                  {switchMessage}
                </p>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Maintenance;
